export default __webpack_public_path__ + "static/media/voiceflow.f95fc7f3.png";